import { isNumber } from 'highcharts';
import ConstantApi from '../../../../ConstantApi';
import { fetchAreaMaster } from '../../../areaMaster/areaMaster.actions';
import axiosCall from '../../../axiosCall';
import { fetchColorDetailsWithoutId } from '../../../colorDetails/colorDetails.actions';
import { fetchHSNMaster } from '../../../hsnMaster/hsnMaster.actions';
import { fetchBankName, fetchPartyMasterData, fetchPropertyDataForPartyMasterMaster } from '../../../partyMaster/partyMaster.actions';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE } from '../fabricPoMaster/fabricPoMaster.actionsType';
import {
    CREATE_FABRIC_PO_DETAILS_FAILURE,
    CREATE_FABRIC_PO_DETAILS_FORM,
    CREATE_FABRIC_PO_DETAILS_REQUEST,
    CREATE_FABRIC_PO_DETAILS_SUCCESS,
    DELETE_FABRIC_PO_DETAILS_FAILURE,
    DELETE_FABRIC_PO_DETAILS_REQUEST,
    DELETE_FABRIC_PO_DETAILS_SUCCESS,
    FETCH_FABRIC_PO_DETAILS_FAILURE,
    FETCH_FABRIC_PO_DETAILS_GROUP_LIST_FAILURE,
    FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST,
    FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS,
    FETCH_FABRIC_PO_DETAILS_REQUEST,
    FETCH_FABRIC_PO_DETAILS_SUCCESS,
    FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_FAILURE,
    FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_REQUEST,
    FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE,
    FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST,
    FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS,
    FETCH_FABRIC_PO_UPDATE_LIST_FAILURE,
    FETCH_FABRIC_PO_UPDATE_LIST_REQUEST,
    FETCH_FABRIC_PO_UPDATE_LIST_SUCCESS,
    FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE,
    FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST,
    FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS,
    RESET_FABRIC_PO_DETAILS_INFO,
    UPDATE_FABRIC_PO_DETAILS_FAILURE,
    UPDATE_FABRIC_PO_DETAILS_REQUEST,
    UPDATE_FABRIC_PO_DETAILS_SUCCESS,
    CHECK_ALL_UPDATE_REQUEST_FABRIC,
    CHECK_ALL_UPDATE_SUCCESS_FABRIC,
    CHECK_ALL_UPDATE_FALIURE_FABRIC,
    CLOSE_BTN_POST_REQUEST_FABRIC,
    CLOSE_BTN_POST_SUCCESS_FABRIC,
    CLOSE_BTN_POST_FALIURE_FABRIC,
    FETCH_DIA_DETAILS_DIA_FROM_STYLE_REQUEST,
    FETCH_DIA_DETAILS_DIA_FROM_STYLE_SUCCESS,
    FETCH_DIA_DC_DETAILS_DIA_FROM_STYLE_FAILURE,
    FETCH_FABRIC_PO_DETAILS_GAGE_FROM_STYLE_REQUEST,
    FETCH_FABRIC_PO_DETAILS_GAGE_FROM_STYLE_SUCCESS,
    FETCH_FABRIC_PO_DETAILS_GAGE_FROM_STYLE_FAILURE,
    FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_REQUEST,
    FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_SUCCESS,
    FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_FAILURE,
    FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_REQUEST,
    FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_SUCCESS,
    FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_FAILURE,
    FETCH_CURRENT_RATE_FROM_STYLE_REQUEST,
    FETCH_CURRENT_RATE_FROM_STYLE_SUCCESS,
    FETCH_CURRENT_RATE_FROM_STYLE_FAILURE,
    EDIT_API_SELECTED_ROWS_CALL_REQUEST,
    EDIT_API_SELECTED_ROWS_CALL_SUCCESS,
    EDIT_API_SELECTED_ROWS_CALL_FAILURE
} from './fabricPoDetails.actionsType';
import { fetchFabricPoMasterData } from '../fabricPoMaster/fabricPoMaster.action';
import moment from 'moment';

// FETCH PARTY DETAILS DATA  ?FldFKParty=12
export let fetchFabricPoDetailsWithIdData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricPoDetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_FABRIC_PO_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_PO_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_PO_DETAILS_FAILURE
    };
    return axiosCall(config);
};

// FETCH PARTY DETAILS DATA
export let fetchFabricPoDetailsData = (id) => {
    let config = {
        method: 'get',
        url: ConstantApi.fabricPoDetailsGET,
        responseTypeRequest: FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_FAILURE
    };
    return axiosCall(config);
};
export let fetchFabricPODetailsGroupListDropdown = () => {
    let config = {
        method: 'get',
        url: ConstantApi.fabricPOFabricGroupList,
        responseTypeRequest: FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_PO_DETAILS_GROUP_LIST_FAILURE
    };
    return axiosCall(config);
};

export let fetchFabricPOPreviousGetList = (saleId, styleId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricP0DetailsPreviousGetListGET}?FldSaleOrders=${saleId}&FldFKStyle=${styleId}`,
        responseTypeRequest: FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE
    };
    return axiosCall(config);
};

// CREATE PARTY DETAILS FORM
export let createFabricPoDetailsForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_FABRIC_PO_DETAILS_FORM, payload: { key, value } });
    };
};

export let fetchFabricPOUpdateGetList = (selectedRows, totalSum) => {
    // let data = JSON.stringify(selectedRows);
    let ids = selectedRows.map((ele) => ele.fldId);
    let config = {
        method: 'post',
        // data,
        url: `${ConstantApi.fabricP0DetailsUpdateListGET}?FldId=${ids}&Weight=${totalSum}`,
        responseTypeRequest: FETCH_FABRIC_PO_UPDATE_LIST_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_PO_UPDATE_LIST_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_PO_UPDATE_LIST_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

// CREATE PARTY DETAILS
export let createFabricPoDetails = (formData, arrayData, modalClose, id, startDate, endDate, unitId, headerUserForm, isDirectDetails) => {

    // console.log('selectedRowsDetail', selectedRows)

    // let fldId = selectedRows.map((row) => row.fldId);

    let today = new Date();
    let totalSum = formData.fldQuantity;
    let data = JSON.stringify({
        fldId: 0,
        fldFKPoNo: parseInt(formData.fldFKPoNo),
        fldFKStyleNumber: parseInt(formData.fldFKStyleNumber),
        fldStyleNumber: formData.fldStyleNumber || '',
        fldFKSaleOrderNo: parseInt(formData.fldFKSaleOrderNo),
        fldSalesOrderNo: formData.fldSalesOrderNo || '',
        fldFabricGroup: formData.fldFabricGroup,
        tblFabricname: formData.tblFabricname || '',
        fldYarnCounts: formData.fldYarnCounts || '',
        fldDia: formData.fldDia,
        fldGSM: formData.fldFKGSM,
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup), //fldId
        fldFKFabric: parseInt(formData.fldFKFabric), //fldId
        fldFKYarnCounts: parseInt(formData.fldFKYarnCounts),
        fldFKColour: parseInt(formData.fldFKColour) || 3,
        // fldFKColour: parseInt(fabricPoDetailsForm.fldFKColour) || 3,
        fldFKDia: parseInt(formData.fldFKDia),
        fldFDia: formData.fldDia,
        fldGage: formData.fldGage,
        fldFKGSM: Number(formData.fldFKGSM),
        fldLoopLength: formData.fldLoopLength,
        fldFKWeightinKG: Number(formData.fldFKWeightinKG) || 0,
        fldFKRatePerKG: Number(formData.fldFKRatePerKG) || 0,
        fldTotalRate: Number(formData.fldTotalRate) || 0,
        fldDiscountPercentage: Number(formData.fldDiscountPercentage),
        fldIGSTPercentage: Number(formData.fldIGSTPercentage),
        fldSGSTPercentage: Number(formData.fldSGSTPercentage),
        fldCGSTPercentage: Number(formData.fldCGSTPercentage),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        FldAgentName: formData.FldAgentName || 'NA',
        FldMillName: formData.FldMillName || 'NA',
        fldCreatedDt: today.toISOString(),
        fldFKStatus: 0,
        fldFKFabricMaster: Number(formData.fldFKFabricMaster), //fldId
        fldQuantity: Number(formData.fldQuantity),
        fldGrossValue: Number(formData.fldGrossValue),
        fldDiscountValue: Number(formData.fldDiscountValue),
        fldTaxableValue: Number(formData.fldTaxableValue),
        fldIGSTValue: Number(formData.fldIGSTValue),
        fldSGSTValue: Number(formData.fldSGSTValue),
        fldCGSTValue: Number(formData.fldCGSTValue),
        fldGSTValue: Number(formData.fldGSTValue),
        fldTotalValue: Number(formData.fldTotalValue) || 0,
        fldFKColourShade: Number(formData.fldFKColourShade) || 0,
        // fldFKColourShade: fabricPoDetailsForm?.fldFKColourShade && !fabricPoDetailsForm.fldIsCora ? Number(fabricPoDetailsForm.fldFKColourShade) : Number(fabricPoDetailsForm.fldFKColourShade) || 0,
        fldFKHSNCode: Number(formData.fldFKHSNCode),
        fldFKUOM: Number(formData.fldFKUOM),
        fldRate: Number(formData.fldRate),
        fldDeliveryDate: today.toISOString(),
        fldDeletedBy: 0,
        fldColourShade: formData.fldColourShade || '',
        // fldColourShade: fabricPoDetailsForm.fldIsCora ? 'CORA' : fabricPoDetailsForm.fldColourShade || formData.fldColourShade || '',
        fldColour: formData.fldColour || '',
        // fldColour: fabricPoDetailsForm.fldIsCora ? 'CORA' : fabricPoDetailsForm.fldColour,
        FldReason: 'string',
        fldIsCora: formData.fldIsCora || false,
        // fldIsCora: fabricPoDetailsForm.fldIsCora || false,
        // FldFKAgentName: fabricPoDetailsForm.fldFKAgentName || 'NA',
        // FldFKMillName: fabricPoDetailsForm.fldFKMillName || 'NA', 
        FldFKAgentName: formData.fldFKAgentName || 'NA',
        FldFKMillName: formData.fldFKMillName || 'NA',
        FldFkStylePrepFabReqDtlID: Number(formData.FldFkStylePrepFabReqDtlID) || 0,
    });
    // let config = {
    //     method: 'post',
    //     data,
    //     url: `${ConstantApi.fabricPoDetailsPOST}?FldPendingList=${selectedRows}`,
    //     responseTypeRequest: CREATE_FABRIC_PO_DETAILS_REQUEST,
    //     responseTypeSuccess: CREATE_FABRIC_PO_DETAILS_SUCCESS,
    //     responseTypeFailure: CREATE_FABRIC_PO_DETAILS_FAILURE,
    //     resetFormData: isStatus ? FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE : RESET_FABRIC_PO_DETAILS_INFO,
    //     modalClose,
    //     headers: {
    //         'Content-Type': 'application/json'
    //     },
    //     getAllData: fetchFabricPoDetailsWithIdData(parseInt(formData.fldFKPoNo)),
    //     singlApiArray: [fetchFabricPOUpdateGetList(selectedRows, totalSum), fetchFabricPOPreviousGetList(fldFKSaleOrder, fldFKStyle)]
    // };
    let config = {
        method: 'post',
        data: JSON.stringify(arrayData),
        url: `${ConstantApi.fabricPoDetailsPOSTBulk}`,
        responseTypeRequest: CREATE_FABRIC_PO_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_FABRIC_PO_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_FABRIC_PO_DETAILS_FAILURE,
        resetFormData: RESET_FABRIC_PO_DETAILS_INFO,
        headers: {
            'Content-Type': 'application/json'
        },
        modalClose,
        singlApiArray: [isDirectDetails ? fetchFabricPoMasterData(
            moment(headerUserForm.startDate).format('YYYY-MM-DD'),
            moment(headerUserForm.endDate).format('YYYY-MM-DD'),
            headerUserForm.unitId || 1) : ""],
        getAllData: fetchFabricPoDetailsWithIdData(parseInt(id)),
        // singleApiArray: [fetchFabricPoMasterData(startDate, endDate, unitId)]
        // singlApiArray: [fetchFabricPOUpdateGetList(selectedRows, totalSum), fetchFabricPOPreviousGetList(fldFKSaleOrder, fldFKStyle)]
    };
    return axiosCall(config);
};

// GET SINGLE PARTY DETAILS
export let getSingleFabricPoDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricPoDetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE,
        singlApiArray: [
            fetchPropertyDataForPartyMasterMaster(31), // Party Category
            fetchPropertyDataForPartyMasterMaster(23), // Program Type
            fetchAreaMaster(),
            fetchPartyMasterData(),
            fetchBankName(),
            fetchHSNMaster(),
            fetchCommonPropertyById(22),
            fetchCommonPropertyById(68),
            fetchFabricPODetailsGroupListDropdown(),
            fetchCommonPropertyById(18),
            fetchColorDetailsWithoutId()
        ]
    };
    return axiosCall(config);
};

//UPDATE PARTY DETAILS
export let updateFabricPoDetails = (id, formData, parentId, pendingId) => {
    let today = new Date();
    let data = {
        fldId: parseInt(id),
        fldFKPoNo: formData.fldFKPoNo,
        fldStyleNumber: formData.fldStyleNumber,
        fldFKStyleNumber: Number(formData.fldFKStyleNumber),
        fldSalesOrderNo: formData.fldSalesOrderNo,
        fldFKSaleOrderNo: Number(formData.fldFKSaleOrderNo),
        fldFKFabricGroup: Number(formData.fldFKFabricGroup), //fldId
        fldFKFabric: Number(formData.fldFKFabric), //fldId
        fldFKYarnCounts: Number(formData.fldFKYarnCounts),
        fldFKColour: Number(formData.fldFKColour),
        fldFKDia: Number(formData.fldFKDia),
        fldGage: formData.fldGage,
        fldFKGSM: formData.fldFKGSM,
        // fldLoopLength: formData.fldLoopLength,
        fldFKWeightinKG: Number(formData.fldFKWeightinKG),
        fldFKRatePerKG: Number(formData.fldFKRatePerKG),
        fldTotalRate: Number(formData.fldTotalRate),
        fldDiscountPercentage: Number(formData.fldDiscountPercentage),
        fldIGSTPercentage: Number(formData.fldIGSTPercentage),
        fldSGSTPercentage: Number(formData.fldSGSTPercentage),
        fldCGSTPercentage: Number(formData.fldCGSTPercentage),
        fldColour: formData.fldColour || 'black',
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: 1317,
        fldFKFabricMaster: Number(formData.fldFKFabricMaster), //fldId
        fldQuantity: Number(formData.fldQuantity),
        fldGrossValue: Number(formData.fldGrossValue),
        fldDiscountValue: Number(formData.fldDiscountValue),
        fldTaxableValue: Number(formData.fldTaxableValue),
        fldIGSTValue: Number(formData.fldIGSTValue),
        fldSGSTValue: Number(formData.fldSGSTValue),
        fldCGSTValue: Number(formData.fldCGSTValue),
        fldGSTValue: Number(formData.fldGSTValue),
        fldTotalValue: Number(formData.fldTotalValue),
        fldFKColourShade: formData?.fldFKColourShade ? Number(formData.fldFKColourShade) : Number(formData.fldFKColourShade) || 0,
        fldFKHSNCode: Number(formData.fldFKHSNCode),
        fldFKUOM: Number(formData.fldFKUOM),
        fldRate: Number(formData.fldRate),
        fldColourShade: formData.fldColourShade,
        FldReason: 'string',
        fldIsCora: formData.fldIsCora || false
    };


    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.fabricPoDetailsPATCH}/${id}?FldPendingList=${pendingId}`,
        responseTypeRequest: UPDATE_FABRIC_PO_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_FABRIC_PO_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_FABRIC_PO_DETAILS_FAILURE,
        resetFormData: RESET_FABRIC_PO_DETAILS_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchFabricPoDetailsWithIdData(parseInt(parentId))
    };
    return axiosCall(config);
};

// DELETE PARTY DETAILS
export let deleteFabricPoDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.fabricPoDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_FABRIC_PO_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_FABRIC_PO_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_FABRIC_PO_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchFabricPoDetailsWithIdData(parseInt(parentId))
    };
    return axiosCall(config);
};

export let PostCloseIconApi = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconFab}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_FABRIC,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_FABRIC,
        responseTypeFailure: CLOSE_BTN_POST_FALIURE_FABRIC,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let updateCheckAllfabric = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconFabric}/?FldFKPoNo=${id}&FldReason${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CHECK_ALL_UPDATE_REQUEST_FABRIC,
        responseTypeSuccess: CHECK_ALL_UPDATE_SUCCESS_FABRIC,
        responseTypeFailure: CHECK_ALL_UPDATE_FALIURE_FABRIC,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

// for Name have to common for use lists for fabric for Dia dropdown for
export let fetchKnittingDCDetailsDiaFrmStyle = (style, fabGrp, yarnCnt, fabric, fldId) => {
    // const yarndecodedString = decodeURIComponent(yarnCnt);
    // const fabricdecodedString = decodeURIComponent(fabric);
    // console.log('fabricdecodedString', fabricdecodedString);
    // let Url = code === 'FAB' ? ConstantApi.FabricDCDetailsDiaFrmStyleGET : ConstantApi.knittingDCDetailsDiaFrmStyleGET;

    let config = {
        method: 'get',
        url: `${ConstantApi.FabricDCDetailsDiaFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&fldId=${fldId}`,
        responseTypeRequest: FETCH_DIA_DETAILS_DIA_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_DIA_DETAILS_DIA_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_DIA_DC_DETAILS_DIA_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};


export let fetchFabricPoDetailsGaugeFrmStyle = (style, fabGrp, yarnCnt, fabric, fldId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.FabricPODetailsGaugeFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&fldId=${fldId}`,
        responseTypeRequest: FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};

export let fetchFabricPoDetailsLoopFrmStyle = (style, fabGrp, yarnCnt, fabric, fldId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.FabricPODetailsLoopFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&fldId=${fldId}`,
        responseTypeRequest: FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};



export let fetchCurrentRate = (salesId, YarnId, fabricId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricCurrentRate}?FldFKSaleOrderID=${salesId}&FldFKYarnId=${YarnId}&FldFKFabricId=${fabricId}`,
        responseTypeRequest: FETCH_CURRENT_RATE_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_CURRENT_RATE_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_CURRENT_RATE_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};


export const editSelectedRowsGet = (id) => {

    let config = {
        method: 'get',
        url: `${ConstantApi.editPrevListGetFabric}/${id}`,
        responseTypeRequest: EDIT_API_SELECTED_ROWS_CALL_REQUEST,
        responseTypeSuccess: EDIT_API_SELECTED_ROWS_CALL_SUCCESS,
        responseTypeFailure: EDIT_API_SELECTED_ROWS_CALL_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
}